import { render } from "./TopicDetailModal.vue?vue&type=template&id=bceb1484&scoped=true"
import script from "./TopicDetailModal.vue?vue&type=script&lang=js"
export * from "./TopicDetailModal.vue?vue&type=script&lang=js"

import "./TopicDetailModal.vue?vue&type=style&index=0&id=bceb1484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bceb1484"]])

export default __exports__